import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/client';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { App } from './App';
import { getRoutes } from './routes';

NewRelicBridge.init();

document.addEventListener('DOMContentLoaded', function () {
  const clientContext = new ClientContext();
  clientContext.setExperienceRoutes(getRoutes());
  clientContext.render(<App />);
});
